module.exports = __webpack_public_path__ + "img/order.ef7a0e22.png";